"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DDB - Parameter Metadata Service
 * Set from Package Json
 *
 * The version of the OpenAPI document: 1.22.11
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTagsSortByEnum = exports.GetTagsOrderEnum = exports.GetTagTypesSortByEnum = exports.GetTagTypesOrderEnum = exports.GetTagLinksSortByEnum = exports.GetTagLinksOrderEnum = exports.ParameterMetadataApi = exports.ParameterMetadataApiFactory = exports.ParameterMetadataApiFp = exports.ParameterMetadataApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * ParameterMetadataApi - axios parameter creator
 * @export
 */
var ParameterMetadataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Add new tag. Note - requires Admin privileges if custom tag type not allowed.
         * @summary Add Tag
         * @param {PostTagBody} postTagBody tag object that needs to be added to the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTag: function (postTagBody_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([postTagBody_1], args_1, true), void 0, function (postTagBody, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postTagBody' is not null or undefined
                            (0, common_1.assertParamExists)('addTag', 'postTagBody', postTagBody);
                            localVarPath = "/tags";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postTagBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Add a new tag link to the specified tag id
         * @summary Add a new tag link to the store
         * @param {object} tagId ID of tag to return
         * @param {Array<PostTagLinkBodyInner>} postTagLinkBodyInner TagLink array that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTagLink: function (tagId_1, postTagLinkBodyInner_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tagId_1, postTagLinkBodyInner_1], args_1, true), void 0, function (tagId, postTagLinkBodyInner, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('addTagLink', 'tagId', tagId);
                            // verify required parameter 'postTagLinkBodyInner' is not null or undefined
                            (0, common_1.assertParamExists)('addTagLink', 'postTagLinkBodyInner', postTagLinkBodyInner);
                            localVarPath = "/tags/{tag_id}/links"
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postTagLinkBodyInner, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Adds a new tag type to the database. Note - you need to be an admin to use this route
         * @summary Add a new tag type to the database (Application Admin only)
         * @param {PostTagTypeBody} postTagTypeBody TagLink object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTagType: function (postTagTypeBody_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([postTagTypeBody_1], args_1, true), void 0, function (postTagTypeBody, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'postTagTypeBody' is not null or undefined
                            (0, common_1.assertParamExists)('addTagType', 'postTagTypeBody', postTagTypeBody);
                            localVarPath = "/tag_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postTagTypeBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Deletes a tag by given the unique id. Note - requires Admin privileges.
         * @summary Delete an existing tag (Application Admin only)
         * @param {object} tagId ID of tag to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagById: function (tagId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tagId_1], args_1, true), void 0, function (tagId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTagById', 'tagId', tagId);
                            localVarPath = "/tags/{tag_id}"
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * removes a link between a tag type and a reference ids
         * @summary Delete an existing tag link
         * @param {object} tagId ID of tag to return
         * @param {object} referenceId reference id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagLink: function (tagId_1, referenceId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tagId_1, referenceId_1], args_1, true), void 0, function (tagId, referenceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTagLink', 'tagId', tagId);
                            // verify required parameter 'referenceId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTagLink', 'referenceId', referenceId);
                            localVarPath = "/tags/{tag_id}/links/{reference_id}"
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)))
                                .replace("{".concat("reference_id", "}"), encodeURIComponent(String(referenceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Removes a single tag type. Note - you need to be an admin to use this route
         * @summary Remove a tag type (Application Admin only)
         * @param {object} tagTypeId ID of tag type to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagType: function (tagTypeId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tagTypeId_1], args_1, true), void 0, function (tagTypeId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('deleteTagType', 'tagTypeId', tagTypeId);
                            localVarPath = "/tag_types/{tag_type_id}"
                                .replace("{".concat("tag_type_id", "}"), encodeURIComponent(String(tagTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a single tag
         * @summary Find tag by ID
         * @param {object} tagId ID of tag to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagById: function (tagId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tagId_1], args_1, true), void 0, function (tagId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('getTagById', 'tagId', tagId);
                            localVarPath = "/tags/{tag_id}"
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * gets an existing tag link between resources
         * @summary get an existing tag link
         * @param {object} tagId ID of tag to return
         * @param {object} referenceId reference id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagLink: function (tagId_1, referenceId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tagId_1, referenceId_1], args_1, true), void 0, function (tagId, referenceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('getTagLink', 'tagId', tagId);
                            // verify required parameter 'referenceId' is not null or undefined
                            (0, common_1.assertParamExists)('getTagLink', 'referenceId', referenceId);
                            localVarPath = "/tags/{tag_id}/links/{reference_id}"
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)))
                                .replace("{".concat("reference_id", "}"), encodeURIComponent(String(referenceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns multiple tag links
         * @summary Find tag links
         * @param {object} tagId ID of tag to return
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {GetTagLinksOrderEnum} [order] sort order direction
         * @param {GetTagLinksSortByEnum} [sortBy] Field by which to sort by
         * @param {Array<object>} [referenceId] reference ids to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagLinks: function (tagId_1, pageLimit_1, after_1, before_1, showActive_1, showDeleted_1, order_1, sortBy_1, referenceId_1) {
            var args_1 = [];
            for (var _i = 9; _i < arguments.length; _i++) {
                args_1[_i - 9] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tagId_1, pageLimit_1, after_1, before_1, showActive_1, showDeleted_1, order_1, sortBy_1, referenceId_1], args_1, true), void 0, function (tagId, pageLimit, after, before, showActive, showDeleted, order, sortBy, referenceId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('getTagLinks', 'tagId', tagId);
                            localVarPath = "/tags/{tag_id}/links"
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (showActive !== undefined) {
                                localVarQueryParameter['show_active'] = showActive;
                            }
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (referenceId) {
                                localVarQueryParameter['reference_id'] = referenceId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a single tag type
         * @summary Find tag type by ID
         * @param {object} tagTypeId ID of tag type to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagType: function (tagTypeId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tagTypeId_1], args_1, true), void 0, function (tagTypeId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('getTagType', 'tagTypeId', tagTypeId);
                            localVarPath = "/tag_types/{tag_type_id}"
                                .replace("{".concat("tag_type_id", "}"), encodeURIComponent(String(tagTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns multiple tag types
         * @summary Find tag types
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {GetTagTypesOrderEnum} [order] sort order direction
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {GetTagTypesSortByEnum} [sortBy] Field by which to sort by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagTypes: function (pageLimit_1, after_1, before_1, order_1, showActive_1, showDeleted_1, sortBy_1) {
            var args_1 = [];
            for (var _i = 7; _i < arguments.length; _i++) {
                args_1[_i - 7] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([pageLimit_1, after_1, before_1, order_1, showActive_1, showDeleted_1, sortBy_1], args_1, true), void 0, function (pageLimit, after, before, order, showActive, showDeleted, sortBy, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/tag_types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (showActive !== undefined) {
                                localVarQueryParameter['show_active'] = showActive;
                            }
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns multiple tags
         * @summary Find tags
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {GetTagsOrderEnum} [order] sort order direction
         * @param {GetTagsSortByEnum} [sortBy] Field by which to sort by
         * @param {Array<object>} [referenceId] reference_id from tag link
         * @param {string} [referenceTable] table referenced, usually parameters
         * @param {Array<object>} [tagTypeId] tag_type_id from tag_link/tag_type link, returns all tags with the given tag_type
         * @param {Array<object>} [tagScope] one or more project_id, returns all tags with the given tag_scope. An empty (null) query string filters out all tags with a tag scope, leaving only global tags.
         * @param {boolean} [omitGlobal] if true omits all global tags (those with tag_scope&#x3D;null) from the result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: function (pageLimit_1, after_1, before_1, showActive_1, showDeleted_1, order_1, sortBy_1, referenceId_1, referenceTable_1, tagTypeId_1, tagScope_1, omitGlobal_1) {
            var args_1 = [];
            for (var _i = 12; _i < arguments.length; _i++) {
                args_1[_i - 12] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([pageLimit_1, after_1, before_1, showActive_1, showDeleted_1, order_1, sortBy_1, referenceId_1, referenceTable_1, tagTypeId_1, tagScope_1, omitGlobal_1], args_1, true), void 0, function (pageLimit, after, before, showActive, showDeleted, order, sortBy, referenceId, referenceTable, tagTypeId, tagScope, omitGlobal, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/tags";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            if (pageLimit !== undefined) {
                                localVarQueryParameter['page_limit'] = pageLimit;
                            }
                            if (after !== undefined) {
                                localVarQueryParameter['after'] = after;
                            }
                            if (before !== undefined) {
                                localVarQueryParameter['before'] = before;
                            }
                            if (showActive !== undefined) {
                                localVarQueryParameter['show_active'] = showActive;
                            }
                            if (showDeleted !== undefined) {
                                localVarQueryParameter['show_deleted'] = showDeleted;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sort_by'] = sortBy;
                            }
                            if (referenceId) {
                                localVarQueryParameter['reference_id'] = referenceId;
                            }
                            if (referenceTable !== undefined) {
                                localVarQueryParameter['reference_table'] = referenceTable;
                            }
                            if (tagTypeId) {
                                localVarQueryParameter['tag_type_id'] = tagTypeId;
                            }
                            if (tagScope) {
                                localVarQueryParameter['tag_scope'] = tagScope;
                            }
                            if (omitGlobal !== undefined) {
                                localVarQueryParameter['omit_global'] = omitGlobal;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Edits a tag by given the unique id. Note - requires Admin privileges.
         * @summary Edit an existing tag (Application Admin only)
         * @param {object} tagId ID of tag to return
         * @param {PatchTagBody} patchTagBody tag object that needs to be added to the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTagById: function (tagId_1, patchTagBody_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tagId_1, patchTagBody_1], args_1, true), void 0, function (tagId, patchTagBody, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('patchTagById', 'tagId', tagId);
                            // verify required parameter 'patchTagBody' is not null or undefined
                            (0, common_1.assertParamExists)('patchTagById', 'patchTagBody', patchTagBody);
                            localVarPath = "/tags/{tag_id}"
                                .replace("{".concat("tag_id", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchTagBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Put multiple new tag links or update existing ones
         * @summary Put new or update existing tag links
         * @param {Array<PutTagLinksBodyInner>} putTagLinksBodyInner TagLink array that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTagLinks: function (putTagLinksBodyInner_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([putTagLinksBodyInner_1], args_1, true), void 0, function (putTagLinksBodyInner, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'putTagLinksBodyInner' is not null or undefined
                            (0, common_1.assertParamExists)('putTagLinks', 'putTagLinksBodyInner', putTagLinksBodyInner);
                            localVarPath = "/tag_links";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(putTagLinksBodyInner, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates a single tag type. Note - you need to be an admin to use this route
         * @summary Updates tag type (Application Admin only)
         * @param {object} tagTypeId ID of tag type to return
         * @param {PatchTagTypeBody} patchTagTypeBody TagLink object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagType: function (tagTypeId_1, patchTagTypeBody_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([tagTypeId_1, patchTagTypeBody_1], args_1, true), void 0, function (tagTypeId, patchTagTypeBody, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('updateTagType', 'tagTypeId', tagTypeId);
                            // verify required parameter 'patchTagTypeBody' is not null or undefined
                            (0, common_1.assertParamExists)('updateTagType', 'patchTagTypeBody', patchTagTypeBody);
                            localVarPath = "/tag_types/{tag_type_id}"
                                .replace("{".concat("tag_type_id", "}"), encodeURIComponent(String(tagTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication OAuth2 required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "OAuth2", ["api://ddb-api/.default"], configuration)
                                // authentication api_key required
                            ];
                        case 1:
                            // authentication OAuth2 required
                            // oauth required
                            _a.sent();
                            // authentication api_key required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 2:
                            // authentication api_key required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patchTagTypeBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ParameterMetadataApiAxiosParamCreator = ParameterMetadataApiAxiosParamCreator;
/**
 * ParameterMetadataApi - functional programming interface
 * @export
 */
var ParameterMetadataApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ParameterMetadataApiAxiosParamCreator)(configuration);
    return {
        /**
         * Add new tag. Note - requires Admin privileges if custom tag type not allowed.
         * @summary Add Tag
         * @param {PostTagBody} postTagBody tag object that needs to be added to the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTag: function (postTagBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addTag(postTagBody, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.addTag']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Add a new tag link to the specified tag id
         * @summary Add a new tag link to the store
         * @param {object} tagId ID of tag to return
         * @param {Array<PostTagLinkBodyInner>} postTagLinkBodyInner TagLink array that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTagLink: function (tagId, postTagLinkBodyInner, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addTagLink(tagId, postTagLinkBodyInner, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.addTagLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Adds a new tag type to the database. Note - you need to be an admin to use this route
         * @summary Add a new tag type to the database (Application Admin only)
         * @param {PostTagTypeBody} postTagTypeBody TagLink object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTagType: function (postTagTypeBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addTagType(postTagTypeBody, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.addTagType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Deletes a tag by given the unique id. Note - requires Admin privileges.
         * @summary Delete an existing tag (Application Admin only)
         * @param {object} tagId ID of tag to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagById: function (tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTagById(tagId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.deleteTagById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * removes a link between a tag type and a reference ids
         * @summary Delete an existing tag link
         * @param {object} tagId ID of tag to return
         * @param {object} referenceId reference id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagLink: function (tagId, referenceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTagLink(tagId, referenceId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.deleteTagLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Removes a single tag type. Note - you need to be an admin to use this route
         * @summary Remove a tag type (Application Admin only)
         * @param {object} tagTypeId ID of tag type to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagType: function (tagTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTagType(tagTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.deleteTagType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a single tag
         * @summary Find tag by ID
         * @param {object} tagId ID of tag to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagById: function (tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTagById(tagId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.getTagById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * gets an existing tag link between resources
         * @summary get an existing tag link
         * @param {object} tagId ID of tag to return
         * @param {object} referenceId reference id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagLink: function (tagId, referenceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTagLink(tagId, referenceId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.getTagLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns multiple tag links
         * @summary Find tag links
         * @param {object} tagId ID of tag to return
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {GetTagLinksOrderEnum} [order] sort order direction
         * @param {GetTagLinksSortByEnum} [sortBy] Field by which to sort by
         * @param {Array<object>} [referenceId] reference ids to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagLinks: function (tagId, pageLimit, after, before, showActive, showDeleted, order, sortBy, referenceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTagLinks(tagId, pageLimit, after, before, showActive, showDeleted, order, sortBy, referenceId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.getTagLinks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a single tag type
         * @summary Find tag type by ID
         * @param {object} tagTypeId ID of tag type to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagType: function (tagTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTagType(tagTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.getTagType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns multiple tag types
         * @summary Find tag types
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {GetTagTypesOrderEnum} [order] sort order direction
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {GetTagTypesSortByEnum} [sortBy] Field by which to sort by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagTypes: function (pageLimit, after, before, order, showActive, showDeleted, sortBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTagTypes(pageLimit, after, before, order, showActive, showDeleted, sortBy, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.getTagTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns multiple tags
         * @summary Find tags
         * @param {number} [pageLimit] This is the maximum number of objects that may be returned. A query may  return fewer than the value of limit due to filtering. Do not depend on the  number of results being fewer than the limit value to indicate your query  reaching the end of the list of data, the absence of next or previous in the  response will indicate the end of the data.
         * @param {string} [after] This is the cursor that points to the end of the page of data that has been returned
         * @param {string} [before] This is the cursor that points to the start of the page of data that has been returned.
         * @param {boolean} [showActive] Flags whether to include non-deleted (i.e. active) items in the response
         * @param {boolean} [showDeleted] Flags whether to include deleted items in the response
         * @param {GetTagsOrderEnum} [order] sort order direction
         * @param {GetTagsSortByEnum} [sortBy] Field by which to sort by
         * @param {Array<object>} [referenceId] reference_id from tag link
         * @param {string} [referenceTable] table referenced, usually parameters
         * @param {Array<object>} [tagTypeId] tag_type_id from tag_link/tag_type link, returns all tags with the given tag_type
         * @param {Array<object>} [tagScope] one or more project_id, returns all tags with the given tag_scope. An empty (null) query string filters out all tags with a tag scope, leaving only global tags.
         * @param {boolean} [omitGlobal] if true omits all global tags (those with tag_scope&#x3D;null) from the result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: function (pageLimit, after, before, showActive, showDeleted, order, sortBy, referenceId, referenceTable, tagTypeId, tagScope, omitGlobal, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTags(pageLimit, after, before, showActive, showDeleted, order, sortBy, referenceId, referenceTable, tagTypeId, tagScope, omitGlobal, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.getTags']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Edits a tag by given the unique id. Note - requires Admin privileges.
         * @summary Edit an existing tag (Application Admin only)
         * @param {object} tagId ID of tag to return
         * @param {PatchTagBody} patchTagBody tag object that needs to be added to the database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTagById: function (tagId, patchTagBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchTagById(tagId, patchTagBody, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.patchTagById']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Put multiple new tag links or update existing ones
         * @summary Put new or update existing tag links
         * @param {Array<PutTagLinksBodyInner>} putTagLinksBodyInner TagLink array that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTagLinks: function (putTagLinksBodyInner, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.putTagLinks(putTagLinksBodyInner, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.putTagLinks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updates a single tag type. Note - you need to be an admin to use this route
         * @summary Updates tag type (Application Admin only)
         * @param {object} tagTypeId ID of tag type to return
         * @param {PatchTagTypeBody} patchTagTypeBody TagLink object that needs to be added to the store
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagType: function (tagTypeId, patchTagTypeBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateTagType(tagTypeId, patchTagTypeBody, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ParameterMetadataApi.updateTagType']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ParameterMetadataApiFp = ParameterMetadataApiFp;
/**
 * ParameterMetadataApi - factory interface
 * @export
 */
var ParameterMetadataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ParameterMetadataApiFp)(configuration);
    return {
        /**
         * Add new tag. Note - requires Admin privileges if custom tag type not allowed.
         * @summary Add Tag
         * @param {ParameterMetadataApiAddTagRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTag: function (requestParameters, options) {
            return localVarFp.addTag(requestParameters.postTagBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add a new tag link to the specified tag id
         * @summary Add a new tag link to the store
         * @param {ParameterMetadataApiAddTagLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTagLink: function (requestParameters, options) {
            return localVarFp.addTagLink(requestParameters.tagId, requestParameters.postTagLinkBodyInner, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Adds a new tag type to the database. Note - you need to be an admin to use this route
         * @summary Add a new tag type to the database (Application Admin only)
         * @param {ParameterMetadataApiAddTagTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTagType: function (requestParameters, options) {
            return localVarFp.addTagType(requestParameters.postTagTypeBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Deletes a tag by given the unique id. Note - requires Admin privileges.
         * @summary Delete an existing tag (Application Admin only)
         * @param {ParameterMetadataApiDeleteTagByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagById: function (requestParameters, options) {
            return localVarFp.deleteTagById(requestParameters.tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * removes a link between a tag type and a reference ids
         * @summary Delete an existing tag link
         * @param {ParameterMetadataApiDeleteTagLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagLink: function (requestParameters, options) {
            return localVarFp.deleteTagLink(requestParameters.tagId, requestParameters.referenceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Removes a single tag type. Note - you need to be an admin to use this route
         * @summary Remove a tag type (Application Admin only)
         * @param {ParameterMetadataApiDeleteTagTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTagType: function (requestParameters, options) {
            return localVarFp.deleteTagType(requestParameters.tagTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a single tag
         * @summary Find tag by ID
         * @param {ParameterMetadataApiGetTagByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagById: function (requestParameters, options) {
            return localVarFp.getTagById(requestParameters.tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * gets an existing tag link between resources
         * @summary get an existing tag link
         * @param {ParameterMetadataApiGetTagLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagLink: function (requestParameters, options) {
            return localVarFp.getTagLink(requestParameters.tagId, requestParameters.referenceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns multiple tag links
         * @summary Find tag links
         * @param {ParameterMetadataApiGetTagLinksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagLinks: function (requestParameters, options) {
            return localVarFp.getTagLinks(requestParameters.tagId, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.showActive, requestParameters.showDeleted, requestParameters.order, requestParameters.sortBy, requestParameters.referenceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a single tag type
         * @summary Find tag type by ID
         * @param {ParameterMetadataApiGetTagTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagType: function (requestParameters, options) {
            return localVarFp.getTagType(requestParameters.tagTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns multiple tag types
         * @summary Find tag types
         * @param {ParameterMetadataApiGetTagTypesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagTypes: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getTagTypes(requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.order, requestParameters.showActive, requestParameters.showDeleted, requestParameters.sortBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns multiple tags
         * @summary Find tags
         * @param {ParameterMetadataApiGetTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getTags(requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.showActive, requestParameters.showDeleted, requestParameters.order, requestParameters.sortBy, requestParameters.referenceId, requestParameters.referenceTable, requestParameters.tagTypeId, requestParameters.tagScope, requestParameters.omitGlobal, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Edits a tag by given the unique id. Note - requires Admin privileges.
         * @summary Edit an existing tag (Application Admin only)
         * @param {ParameterMetadataApiPatchTagByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchTagById: function (requestParameters, options) {
            return localVarFp.patchTagById(requestParameters.tagId, requestParameters.patchTagBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Put multiple new tag links or update existing ones
         * @summary Put new or update existing tag links
         * @param {ParameterMetadataApiPutTagLinksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTagLinks: function (requestParameters, options) {
            return localVarFp.putTagLinks(requestParameters.putTagLinksBodyInner, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates a single tag type. Note - you need to be an admin to use this route
         * @summary Updates tag type (Application Admin only)
         * @param {ParameterMetadataApiUpdateTagTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagType: function (requestParameters, options) {
            return localVarFp.updateTagType(requestParameters.tagTypeId, requestParameters.patchTagTypeBody, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ParameterMetadataApiFactory = ParameterMetadataApiFactory;
/**
 * ParameterMetadataApi - object-oriented interface
 * @export
 * @class ParameterMetadataApi
 * @extends {BaseAPI}
 */
var ParameterMetadataApi = /** @class */ (function (_super) {
    __extends(ParameterMetadataApi, _super);
    function ParameterMetadataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add new tag. Note - requires Admin privileges if custom tag type not allowed.
     * @summary Add Tag
     * @param {ParameterMetadataApiAddTagRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.addTag = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).addTag(requestParameters.postTagBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add a new tag link to the specified tag id
     * @summary Add a new tag link to the store
     * @param {ParameterMetadataApiAddTagLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.addTagLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).addTagLink(requestParameters.tagId, requestParameters.postTagLinkBodyInner, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Adds a new tag type to the database. Note - you need to be an admin to use this route
     * @summary Add a new tag type to the database (Application Admin only)
     * @param {ParameterMetadataApiAddTagTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.addTagType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).addTagType(requestParameters.postTagTypeBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Deletes a tag by given the unique id. Note - requires Admin privileges.
     * @summary Delete an existing tag (Application Admin only)
     * @param {ParameterMetadataApiDeleteTagByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.deleteTagById = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).deleteTagById(requestParameters.tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * removes a link between a tag type and a reference ids
     * @summary Delete an existing tag link
     * @param {ParameterMetadataApiDeleteTagLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.deleteTagLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).deleteTagLink(requestParameters.tagId, requestParameters.referenceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Removes a single tag type. Note - you need to be an admin to use this route
     * @summary Remove a tag type (Application Admin only)
     * @param {ParameterMetadataApiDeleteTagTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.deleteTagType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).deleteTagType(requestParameters.tagTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a single tag
     * @summary Find tag by ID
     * @param {ParameterMetadataApiGetTagByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.getTagById = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).getTagById(requestParameters.tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * gets an existing tag link between resources
     * @summary get an existing tag link
     * @param {ParameterMetadataApiGetTagLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.getTagLink = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).getTagLink(requestParameters.tagId, requestParameters.referenceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns multiple tag links
     * @summary Find tag links
     * @param {ParameterMetadataApiGetTagLinksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.getTagLinks = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).getTagLinks(requestParameters.tagId, requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.showActive, requestParameters.showDeleted, requestParameters.order, requestParameters.sortBy, requestParameters.referenceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a single tag type
     * @summary Find tag type by ID
     * @param {ParameterMetadataApiGetTagTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.getTagType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).getTagType(requestParameters.tagTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns multiple tag types
     * @summary Find tag types
     * @param {ParameterMetadataApiGetTagTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.getTagTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterMetadataApiFp)(this.configuration).getTagTypes(requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.order, requestParameters.showActive, requestParameters.showDeleted, requestParameters.sortBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns multiple tags
     * @summary Find tags
     * @param {ParameterMetadataApiGetTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.getTags = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ParameterMetadataApiFp)(this.configuration).getTags(requestParameters.pageLimit, requestParameters.after, requestParameters.before, requestParameters.showActive, requestParameters.showDeleted, requestParameters.order, requestParameters.sortBy, requestParameters.referenceId, requestParameters.referenceTable, requestParameters.tagTypeId, requestParameters.tagScope, requestParameters.omitGlobal, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Edits a tag by given the unique id. Note - requires Admin privileges.
     * @summary Edit an existing tag (Application Admin only)
     * @param {ParameterMetadataApiPatchTagByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.patchTagById = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).patchTagById(requestParameters.tagId, requestParameters.patchTagBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Put multiple new tag links or update existing ones
     * @summary Put new or update existing tag links
     * @param {ParameterMetadataApiPutTagLinksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.putTagLinks = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).putTagLinks(requestParameters.putTagLinksBodyInner, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates a single tag type. Note - you need to be an admin to use this route
     * @summary Updates tag type (Application Admin only)
     * @param {ParameterMetadataApiUpdateTagTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParameterMetadataApi
     */
    ParameterMetadataApi.prototype.updateTagType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ParameterMetadataApiFp)(this.configuration).updateTagType(requestParameters.tagTypeId, requestParameters.patchTagTypeBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ParameterMetadataApi;
}(base_1.BaseAPI));
exports.ParameterMetadataApi = ParameterMetadataApi;
/**
 * @export
 */
exports.GetTagLinksOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
};
/**
 * @export
 */
exports.GetTagLinksSortByEnum = {
    CreatedAt: 'created_at'
};
/**
 * @export
 */
exports.GetTagTypesOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
};
/**
 * @export
 */
exports.GetTagTypesSortByEnum = {
    Name: 'name',
    CreatedAt: 'created_at'
};
/**
 * @export
 */
exports.GetTagsOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
};
/**
 * @export
 */
exports.GetTagsSortByEnum = {
    Name: 'name',
    CreatedAt: 'created_at'
};
